import React from 'react'
import { useTranslation } from 'react-i18next'
import { Paragraph, Button, Separator, LayoutBand, Row, H4, H6 } from '@fs/zion-ui'
import Head, { Title } from '@fs/zion-head'
import { Link } from '@fs/zion-router-base'
import NotFoundImage from './images/NotFoundImage'

export default function NotFound() {
  const [t] = useTranslation()

  return (
    <>
      <Title>{t('not-found.title', 'Page Not Found')}</Title>
      <Head>
        <meta name="prerender-status-code" content="404" />
      </Head>
      <LayoutBand maxWidth="sm" data-testid="notfound" style={{ textAlign: 'center' }}>
        <NotFoundImage />
        <H4 centered>{t('not-found.header', 'Well, this is unexpected...')}</H4>
        <Paragraph centered>
          {t(
            'not-found.body',
            "We can help you search literally billions of records, but we can't seem to find the page you're looking for."
          )}
        </Paragraph>
        <Separator size="md" />
        <H6 centered>{t('not-found.whats-next', "What's Next")}</H6>
        <Separator size="xxs" />
        <Row alignX="center">
          <Button
            emphasis="medium"
            onClick={() => {
              typeof window !== 'undefined' && window.location.reload()
            }}
          >
            {t('not-found.option-reload', 'Reload the Page')}
          </Button>
        </Row>
        <Separator size="sm" />
        <Link external to="/help/helpcenter/">
          {t('not-found.option-help-center', 'Visit the Help Center')}
        </Link>
        <Separator size="xs" />
        <Link external to="/search/">
          {t('not-found.option-records', 'Find Historical Records')}
        </Link>
        <Separator size="xs" />
        <Link external to="/site-map">
          {t('not-found.option-site-map', 'View the Site Map')}
        </Link>
        <Separator size="xxs" />
        <Paragraph centered size="sm">
          {t('not-found.option-other', 'Or choose a new activity from the main site menu.')}
        </Paragraph>
      </LayoutBand>
    </>
  )
}
